module.exports = __webpack_public_path__ + "static/img/mysterious_bigshot.32c6dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/financialCompetition/mysterious_bigshot.png
// module id = 5WOt
// module chunks = 86